// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3qPig","item":"PaymentsMobile_item__3HxsQ","label":"PaymentsMobile_label__1uv1s","amount":"PaymentsMobile_amount__57sau"};